<div class="container cart-checkout-page">
    <div class="content-checkout" *ngIf="!totemActive">
        <div class="loading-container" *ngIf="!loaded || waiting">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>

        <div class="list-products-cart item-checkout">
            <div class="flex-continue-back" (click)="goBack()">
                <i class="fa-light fa-arrow-left"></i>
                <p class="m-0">Continuar comprando</p>
            </div>
            <div class="cart-title-row">
                <p class="title-item-checkout">Carrito de compra</p>
                <button class="btn-clear-cart" *ngIf="shoppingCartUser?.length > 0" (click)="confirmClearCart()" title="Vaciar carrito">
                    <i class="fa-light fa-trash-can"></i>
                </button>
            </div>
            <div class="time-checkout" *ngIf="shoppingCartUser?.length <= 0 && loaded">
                <p class="m-0">
                    <i class="fa-circle-info icon-primary" style="margin-right: 8px;"
                        [class]="!totemActive?'fa-light':'fa-solid'"></i>Aún no has añadido
                    ninguna entrada.
                </p>
            </div>

            <div class="time-checkout" *ngIf="shoppingCartUser?.length > 0">
                <p class="m-0"><i class="fa-clock icon-primary" [class]="!totemActive?'fa-light':'fa-solid'"
                        style="margin-right: 8px;"></i>Te quedan <span class="text-time">
                        <span class="number" *ngIf="countdown.days<0">00</span>
                        <span class="number" *ngIf="countdown.days>=0">{{countdown.minutes|number:'2.0-2'}}</span>
                        <span>:</span>
                        <span class="number" *ngIf="countdown.days<0">00</span>
                        <span class="number" *ngIf="countdown.days>=0">{{countdown.seconds|number:'2.0-2'}}</span>
                        <span> minutos</span>
                    </span> para completar el pedido, o las entradas elegidas se
                    perderán.</p>
            </div>
            <div class="booking-list">
                <div *ngFor="let eventLine of shoppingCartUser; trackBy: trackByEventId">
                    <div class="item-booking">
                        <div class="img-event">
                            <img fallimg class="img-event" [src]="urlImages+eventLine.event.image_url" />
                        </div>
                        <div class="info-event">
                            <div class="number-event d-flex align-items-start justify-content-between"
                                style="gap: 12px;">
                                <div class="d-flex title-event">
                                    <span style="min-width: fit-content;">{{eventLine.quantity_event}} x</span>
                                    <span class="title-link"
                                        (click)="openEvent(eventLine.event.id,eventLine.event.title)">{{eventLine.event.title}}</span>
                                </div>
                                <div class="d-flex align-items-center" style="gap: 6px; min-width: fit-content;">
                                    <span *ngIf="eventLine.originalPrice > (eventLine.price - eventLine.fees)" class="price-original-strikethrough">
                                        {{eventLine.originalPrice | number: '1.2-2'}} €
                                    </span>
                                    <p class="total-price-event title-event m-0" [class.price-discounted]="eventLine.originalPrice > (eventLine.price - eventLine.fees)">
                                        {{(eventLine.price - eventLine.fees) | number: '1.2-2'}} €
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex owner-event">
                                <span class="span-author">Creado por: </span>
                                <span class="title-author">{{ eventLine.event.company?.name }}</span>
                            </div>
                            <div class="locate-event d-flex align-items-center">
                                <i class="fa-light fa-map-marker-alt icon-primary"></i>
                                <p class="m-0">{{eventLine.event.space?.address||eventLine.event.address}}</p>
                            </div>
                            <div class="d-flex justify-content-between align-items-end">
                                <div class="show-detail-event d-flex align-items-center pointer-in"
                                    (click)="showDetailTickets(eventLine.event.id)">
                                    <i class="fa-light icon-primary"
                                        [class]="openDetail == eventLine.event.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    <p class="m-0">{{openDetail == eventLine.event.id ? 'Ocultar' : 'Mostrar'}} detalles
                                    </p>
                                </div>
                                <div class="show-detail-event">
                                    <p class="m-0 delete-items" (click)="showDetailTickets(eventLine.event.id)">
                                        Modificar entradas
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-tickets" *ngIf="openDetail == eventLine.event.id || totemActive">
                        <div *ngFor="let line of eventLine.lines; trackBy: trackBySessionId">
                            <div class="d-flex align-items-center" style="gap: 150px;">
                                <div class="date-option d-flex align-items-center">
                                    <i class="fa-light fa-clock icon-primary"></i>
                                    <p class="m-0">{{line.session.start_date | date:'EEEE, dd MMM yyyy':'+0000' |
                                        titlecase}}
                                    </p>
                                    <span *ngIf="(line.session.start_date | date:'HH:mm':'+0000') != '00:00'">-</span>
                                    <p class="m-0" *ngIf="(line.session.start_date | date:'HH:mm':'+0000') != '00:00'">
                                        {{line.session.start_date | date:'HH:mm':'+0000'}}</p>
                                </div>
                            </div>
                            <div *ngFor="let option of line.tickets; trackBy: trackByTicketId" class="info-tickets">
                                <div class="d-flex align-items-center justify-content-between" style="gap: 10px;">
                                    <p class="m-0 title-ticket">{{option.ticket?.name}}</p>
                                    <div class="d-flex align-items-center" style="gap: 6px; min-width: fit-content;">
                                        <span *ngIf="option.discountAmount > 0" class="price-original-strikethrough">
                                            {{option.originalPrice | number: '1.2-2'}} €
                                        </span>
                                        <p class="m-0" [class.price-discounted]="option.discountAmount > 0">
                                            {{(option?.price - option?.fee) | number: '1.2-2'}} €
                                        </p>
                                        <i class="fa-light fa-trash-can icon-primary pointer-in"
                                            (click)="deleteItemCart(option)"></i>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between"
                                    *ngIf="option.abono" style="background: rgba(var(--color-primary-rgb), 0.08); border-radius: 6px; padding: 4px 8px; margin-top: 4px;">
                                    <p class="m-0 style-discount">
                                        <i class="fa-light fa-tag" style="margin-right: 4px;"></i>{{option.abono.name}}
                                        <span *ngIf="option.abono.discount_mode === 'percentage'"> (-{{option.abono.discount_value | number:'1.0-0'}}%)</span>
                                    </p>
                                </div>
                                <div class="m-0" style="gap: 8px;" *ngIf="option.booking.seat">
                                    <span *ngIf="option.booking.seat?.id_map_section">Sección:
                                        {{option.booking.seat?.section?.name ||
                                        option.booking.seat?.map_section?.name}}</span><span
                                        *ngIf="option.booking.seat?.row && !option.booking.seat.hidden && (option.booking.seat?.section?.show_row ?? option.booking.seat?.map_section?.show_row) !== false">, Fila:
                                        {{option.booking.seat?.row}}</span><span *ngIf="option.booking.seat?.seat">{{ (option.booking.seat?.section?.show_seat_label ?? option.booking.seat?.map_section?.show_seat_label) !== false ? ', Asiento: ' : ' ' }}{{option.booking.seat?.seat}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </div>
            </div>
        </div>
        <div class="resume-checkout item-checkout" *ngIf="shoppingCartUser?.length > 0">
            <p class="title-item-checkout">Resumen</p>
            <div *ngFor="let eventLine of shoppingCartUser; trackBy: trackByEventId">
                <div *ngFor="let line of eventLine.lines; trackBy: trackBySessionId">
                    <div class="number-event d-flex align-items-center justify-content-between">
                        <div class="d-flex title-event" style="gap: 10px;">
                            <span>{{line.quantity_session}} x</span>
                            <span>{{eventLine.event.title}}</span>
                        </div>
                        <div class="d-flex align-items-center" style="gap: 6px; min-width: fit-content;">
                            <span *ngIf="line.originalPrice > (line.price - line.fees)" class="price-original-strikethrough">
                                {{line.originalPrice | number: '1.2-2'}} €
                            </span>
                            <p class="total-price-event title-event m-0" [class.price-discounted]="line.originalPrice > (line.price - line.fees)">
                                {{(line.price - line.fees) | number: '1.2-2'}} €
                            </p>
                        </div>
                    </div>
                    <div class="detail-resume">
                        <div class="locate-event d-flex align-items-center">
                            <i class="fa-light fa-map-marker-alt icon-primary"></i>
                            <p class="m-0">{{eventLine.event.space?.address||eventLine.event.address}}</p>
                        </div>
                        <div class="date-option d-flex align-items-center">
                            <i class="fa-light fa-clock icon-primary"></i>
                            <p class="m-0">{{line.session.start_date | date:'EEEE, dd MMM yyyy':'+0000' | titlecase}}
                            </p>
                            <span *ngIf="line.session.start_time">-</span>
                            <p class="m-0" *ngIf="line.session.start_time">{{line.session.start_time |
                                date:'HH:mm':'+0000'}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Sección de subtotales -->
            <div class="order-summary-section" *ngIf="!errorApi">
                <mat-divider></mat-divider>

                <!-- Subtotal sin descuento -->
                <div class="summary-row">
                    <span class="summary-label">Subtotal</span>
                    <span class="summary-value">{{cart?.total_order?.subtotal_without_discount | number: '1.2-2'}} €</span>
                </div>

                <!-- Descuentos (desplegable) -->
                <div class="summary-row summary-row-discount" *ngIf="totalDiscount > 0"
                     (click)="showDiscountDetail = !showDiscountDetail">
                    <span class="summary-label discount-toggle">
                        <i class="fa-light fa-tag"></i>
                        Descuentos
                        <i class="fa-light" [class.fa-chevron-down]="!showDiscountDetail" [class.fa-chevron-up]="showDiscountDetail"></i>
                    </span>
                    <span class="summary-value discount-value">-{{totalDiscount | number: '1.2-2'}} €</span>
                </div>
                <div class="discount-detail-list" *ngIf="showDiscountDetail && totalDiscount > 0">
                    <div class="discount-detail-item" *ngFor="let disc of discountLines">
                        <span class="discount-detail-name">
                            <i class="fa-light fa-minus"></i> {{disc.name}}
                        </span>
                        <span class="discount-detail-amount">-{{disc.total | number: '1.2-2'}} €</span>
                    </div>
                    <div class="discount-detail-item" *ngIf="promoDiscountTotal > 0">
                        <span class="discount-detail-name">
                            <i class="fa-light fa-minus"></i> {{promoDiscountDisplayName || appliedPromoCode}}
                        </span>
                        <span class="discount-detail-amount">-{{promoDiscountTotal | number: '1.2-2'}} €</span>
                    </div>
                </div>

                <!-- Gastos de gestión (solo si > 0) -->
                <div class="summary-row" *ngIf="gestionPrice > 0">
                    <span class="summary-label">Gastos de gestión</span>
                    <span class="summary-value">{{gestionPrice | number: '1.2-2'}} €</span>
                </div>

                <mat-divider></mat-divider>

                <!-- Total final -->
                <div class="summary-row summary-row-total">
                    <span class="summary-label-total">Total <span class="iva-label">(IVA Inc.)</span></span>
                    <span class="summary-value-total">{{totalPrice | number: '1.2-2'}} €</span>
                </div>
            </div>

            <!-- Promo code v2 section -->
            <div class="promo-code-section" *ngIf="!appliedPromoCode">
                <p (click)="openFormDiscount = !openFormDiscount" class="text-open-discount">
                    <i class="fa-light fa-{{!openFormDiscount?'chevron-down':'chevron-up'}} icon-primary"></i>
                    ¿Tienes un código promocional?
                </p>
                <div class="discount-code container-form d-flex align-items-center" [class.hiddenForm]="!openFormDiscount">
                    <input class="w-100" type="text" placeholder="Código promocional" [(ngModel)]="promoCode"
                        (keyup.enter)="applyPromoCodeV2()">
                    <button class="btn-discount cancel-button" [class.active]="promoCode"
                        [disabled]="applyingPromoCode" (click)="applyPromoCodeV2()">
                        {{applyingPromoCode ? '...' : 'Aplicar'}}
                    </button>
                </div>
                <p *ngIf="promoCodeError && openFormDiscount" class="error-discount">
                    <i class="fa-light fa-circle-xmark icon-red icon-error"></i>
                    {{promoCodeError}}
                </p>
            </div>

            <!-- Applied promo code badge -->
            <div class="promo-code-applied d-flex align-items-center justify-content-between" *ngIf="appliedPromoCode">
                <div class="d-flex align-items-center" style="gap: 8px;">
                    <i class="fa-light fa-circle-check icon-primary icon-save"></i>
                    <span>Código aplicado: <strong>{{promoDiscountDisplayName || appliedPromoCode}}</strong></span>
                </div>
                <button class="btn-remove-promo" (click)="removePromoCodeV2()" [disabled]="applyingPromoCode">
                    <i class="fa-light fa-times"></i>
                </button>
            </div>


            <!-- Selector de método de pago -->
            <div class="payment-method-selector" *ngIf="!totemActive">
                <p class="title-payment-method">Método de pago</p>
                <div class="payment-method-options">
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'card'"
                        (click)="selectPaymentMethod('card')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content">
                            <i class="fa-light fa-credit-card"></i>
                            <span>Tarjeta</span>
                        </div>
                    </button>
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'xpay'"
                        [class.disabled]="citylokPaymentMethodsDisabled" [disabled]="citylokPaymentMethodsDisabled"
                        [title]="citylokPaymentMethodsDisabled ? 'Método de pago no disponible' : ''"
                        (click)="selectPaymentMethod('xpay')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content wallet-logos">
                            <img src="assets/img/payment-methods/apple-pay.svg" alt="Apple Pay" class="apple-pay-icon">
                            <span class="logo-divider"></span>
                            <img src="assets/img/payment-methods/google-pay.svg" alt="Google Pay" class="google-pay-icon">
                        </div>
                    </button>
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'bizum'"
                        [class.disabled]="citylokPaymentMethodsDisabled" [disabled]="citylokPaymentMethodsDisabled"
                        [title]="citylokPaymentMethodsDisabled ? 'Método de pago no disponible' : ''"
                        (click)="selectPaymentMethod('bizum')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content">
                            <img src="assets/img/payment-methods/bizum.svg" alt="Bizum" class="bizum-icon">
                            <span>Bizum</span>
                        </div>
                    </button>
                </div>
            </div>

            <div class="checkbox-conditions">
                <mat-checkbox [(ngModel)]="checkAcceptConditions" color="primary">Acepto los <span
                        class="link-terms pointer-in" (click)="openDialogInfo()">términos y condiciones de
                        Citylok.</span></mat-checkbox>
                <mat-checkbox *ngIf="companyGeneralConditions" [(ngModel)]="checkConditionsCompany" color="primary">Acepto las <span class="link-terms pointer-in" (click)="$event.stopPropagation(); openDialogCompanyConditions()">condiciones generales</span> de la organización del evento.</mat-checkbox>
            </div>
            <button class="w-100 primary-button solid btn-finish"
                [class.disabled]="!checkAcceptConditions || (companyGeneralConditions && !checkConditionsCompany)"
                [disabled]="!loaded || waiting || !checkAcceptConditions || (companyGeneralConditions && !checkConditionsCompany)" *ngIf="!errorApi" (click)="openPlatformBuy()">
                Comprar
            </button>
        </div>
    </div>

    <div class="content-checkout totem-checkout" *ngIf="totemActive">
        <div class="loading-container" *ngIf="!loaded || waiting">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>

        <div class="content-checkout-grid-totem">
            <div class="list-products-cart item-checkout">
                <div [class.header-cart-totem]="totemActive">
                    <p class="title-item-checkout">Carrito</p>
                    <!-- Boton vaciar carrito - Totem -->
                    <div class="btn-clear-cart-totem" *ngIf="totemActive && shoppingCartUser?.length > 0"
                        (click)="clearShoppingCart()">
                        <i class="fal fa-trash-can icon-primary"></i>
                        <span>Vaciar carrito</span>
                    </div>
                </div>
                <div class="time-checkout" *ngIf="shoppingCartUser?.length <= 0 && loaded"
                    [class.checkout-info-totem]="totemActive">
                    <p class="m-0">
                        <i class="fa-circle-info icon-primary" style="margin-right: 8px;"
                            [class]="!totemActive?'fa-light':'fa-solid'"></i>Aún no has añadido
                        ninguna entrada.
                    </p>
                </div>

                <div class="time-checkout" *ngIf="shoppingCartUser?.length > 0"
                    [class.checkout-info-totem]="totemActive">
                    <p class="m-0"><i class="fa-clock icon-primary fa-solid" style="margin-right: 8px;"></i>Te quedan
                        <span class="text-time">
                            <span class="number" *ngIf="countdown.days<0">00</span>
                            <span class="number" *ngIf="countdown.days>=0">{{countdown.minutes|number:'2.0-2'}}</span>
                            <span>:</span>
                            <span class="number" *ngIf="countdown.days<0">00</span>
                            <span class="number" *ngIf="countdown.days>=0">{{countdown.seconds|number:'2.0-2'}}</span>
                            <span> minutos</span>
                        </span> para completar el pedido, o las entradas elegidas se
                        perderán.
                    </p>
                </div>
                <!-- Totem List -->
                <mat-divider style="margin-top: 30px;" *ngIf="shoppingCartUser?.length > 0"></mat-divider>
                <div class="booking-list cart-events-totem">
                    <div *ngFor="let eventLine of shoppingCartUser">
                        <div class="detail-tickets">
                            <div *ngFor="let line of eventLine.lines">
                                <div class="item-booking">
                                    <div class="img-event">
                                        <img fallimg class="img-event" [src]="urlImages+eventLine.event.image_url" />
                                    </div>
                                    <div class="info-event">
                                        <div class="number-event d-flex align-items-start justify-content-between"
                                            style="gap: 12px;">
                                            <div class="d-flex title-event">
                                                <span style="min-width: fit-content;">x{{line.quantity_session}}</span>
                                                <span class="title-link"
                                                    (click)="openEvent(eventLine.event.id,eventLine.event.title)">Entradas
                                                    {{eventLine.event.title}}</span>
                                            </div>
                                            <p class="total-price-event title-event m-0"
                                                style="min-width: fit-content;">
                                                {{(line.price-line.fees)-(line.discount||0) | number:
                                                '1.2-2'}} €</p>
                                        </div>
                                        <div class="locate-event d-flex align-items-center">
                                            <i class="fa-light fa-map-marker-alt icon-primary"></i>
                                            <p class="m-0">{{eventLine.event.space?.address||eventLine.event.address}}
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center" style="gap: 150px;">
                                            <div class="date-option d-flex align-items-center">
                                                <i class="fa-light fa-clock icon-primary"></i>
                                                <p class="m-0">
                                                    {{line.session.start_date | date:'EEEE, dd MMM yyyy':'+0000' |
                                                    titlecase}}
                                                </p>
                                                <span *ngIf="line.session.start_time">-</span>
                                                <p class="m-0" *ngIf="line.session.start_time">
                                                    {{line.session.start_time |
                                                    date:'HH:mm':'+0000'}}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="d-flex owner-event">
                                            <span class="span-author">Creado por: </span>
                                            <span class="title-author">{{ eventLine.event.company?.name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                                <div *ngFor="let option of line.tickets">
                                    <div class="info-tickets">
                                        <div class="d-flex align-items-center justify-content-between"
                                            style="gap: 10px;">
                                            <div class="d-flex info-ticket-event" style="gap: 20px;">
                                                <p class="m-0 title-ticket">{{option.ticket?.name}}</p>
                                                <span
                                                    *ngIf="option.booking.seat && option.booking.seat?.id_map_section">
                                                    {{option.booking.seat?.section?.name ||
                                                    option.booking.seat?.map_section?.name}}
                                                </span>
                                                <mat-divider [vertical]="true"></mat-divider>
                                                <div class="m-0 d-flex icon-primary" style="gap: 16px;">
                                                    <p class="m-0" *ngIf="option.booking.seat?.row && !option.booking.seat.hidden && (option.booking.seat?.section?.show_row ?? option.booking.seat?.map_section?.show_row) !== false"> Fila: {{option.booking.seat?.row}}
                                                    </p>
                                                    <p class="m-0" *ngIf="option.booking.seat?.seat"><ng-container *ngIf="(option.booking.seat?.section?.show_seat_label ?? option.booking.seat?.map_section?.show_seat_label) !== false"> Asiento: </ng-container>{{option.booking.seat?.seat}}</p>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center price-ticket"
                                                style="gap: 10px; min-width: fit-content;">
                                                <p class="m-0">{{(option?.price-option?.fee) | number: '1.2-2'}}€
                                                </p>
                                                <i class="fa-light fa-trash-can icon-primary pointer-in fa-xl"
                                                    (click)="deleteItemCart(option)"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between"
                                            *ngIf="option.discount && option.discount > 0">
                                            <p class="m-0">Descuento aplicado: {{option.discountName}}</p>
                                            <p style="margin: 0px 16px; min-width: fit-content;" class="style-discount">
                                                -{{option.discount | number: '1.2-2'}}€</p>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="resume-checkout item-checkout resume-checkout-totem"
                *ngIf="totemActive && shoppingCartUser?.length > 0">
                <div class="btn-clear-cart-totem" (click)="goBack()">
                    <i class="fa-light fa-arrow-left"></i>
                    <span class="m-0">Añade más entradas al carrito</span>
                </div>
                <mat-divider></mat-divider>
                <div class="d-flex align-items-center justify-content-between gestion-price mb-0" *ngIf="!errorApi">
                    <p class="m-0">Gastos de gestión</p>
                    <p class="m-0">{{(gestionPrice) | number: '1.2-2'}}€</p>
                </div>
                <div class="d-flex align-items-center justify-content-between gestion-price mb-0"
                    *ngIf="!errorApi && abonoDiscountTotal > 0">
                    <p class="m-0 style-discount">
                        <i class="fa-light fa-tag" style="margin-right: 4px;"></i>Dto. abono ({{abonoDiscountName}})
                    </p>
                    <p class="m-0 style-discount">-{{abonoDiscountTotal | number: '1.2-2'}}€</p>
                </div>
                <div class="d-flex align-items-center justify-content-between subtotal-price" *ngIf="!errorApi">
                    <p class="m-0">TOTAL (IVA Inc.)</p>
                    <p class="m-0">Total: <span class="total-price">{{(totalPrice) | number: '1.2-2'}}€</span></p>
                </div>
                <mat-divider></mat-divider>
                <div class="checkbox-conditions">
                    <mat-checkbox [(ngModel)]="checkAcceptConditions" color="primary">Acepto los <span
                            class="link-terms pointer-in" (click)="openDialogInfo()">términos y condiciones de
                            Citylok.</span></mat-checkbox>
                    <mat-checkbox *ngIf="companyGeneralConditions" [(ngModel)]="checkConditionsCompany" color="primary">Acepto las <span class="link-terms pointer-in" (click)="$event.stopPropagation(); openDialogCompanyConditions()">condiciones generales</span> de la organización del evento.</mat-checkbox>
                </div>
                <button class="w-100 primary-button solid btn-finish"
                    [class.disabled]="!checkAcceptConditions || (companyGeneralConditions && !checkConditionsCompany)"
                    [disabled]="!loaded || waiting || !checkAcceptConditions || (companyGeneralConditions && !checkConditionsCompany)" *ngIf="!errorApi"
                    (click)="openPlatformBuy()">
                    Pagar
                </button>
            </div>
        </div>
    </div>

    <form action="{{url}}" method="post" id="redsys_form" name="redsys_form" *ngIf="!errorApi && !totemActive">
        <input type="hidden" name="Ds_MerchantParameters" value="{{ Ds_MerchantParameters}}" />
        <input type="hidden" name="Ds_Signature" value="{{ Ds_Signature}}" />
        <input type="hidden" name="Ds_SignatureVersion" value="{{ Ds_SignatureVersion }}" />
        <input type="submit" name="btn_submit" id="btn_submit" value="Send" style="display: none;">
    </form>

</div>